/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { _fn } from '@mairistem/administres-utils';
import { Liste } from '@mairistem/liste';

import type { Profession } from '@/types';

import ProfessionListeTable from './ProfessionListeTable';

interface Props {
  /** Nombre de lignes */
  count?: number;
  /** État du chargement */
  loading?: boolean;
  /** Callback appelé lors du chargement de la liste */
  onLoad?: () => void;
  /** Callback appelé lors d'une saisie dans la barre de recherche */
  onSearch?: (value: string) => Promise<void>;
  /** Callback appelé lors d'un clique sur les filtres */
  onSort?: () => void;
  /** Nombre d'éléments définis par page */
  perPage?: number;
  /** Callback appelé lors de la sélection d'une ligne */
  onSelect?: (qualification: Profession) => void;
  /** Données de la liste */
  professions?: Profession[];
  /** Callback appelé lors de la sauvegarde (liste en saisie) */
  onSave?: (qualification: Profession) => void;
  /** Diplôme sélectionné */
  selectedProfession?: Profession;
  /** Callback appelé lors du reset des items */
  resetSelectedItems?: (qualification: Profession) => void;
  /** Booléen pour gérer l'affichage des professions caduques */
  isShowingCaduque?: boolean;
}

const ProfessionListe = (props: Props) => {
  const {
    count = 0,
    perPage = 50,
    professions = [],
    selectedProfession = {},
    loading = false,
    onLoad = null,
    onSearch = null,
    onSort = null,
    onSelect = null,
    onSave = null,
    resetSelectedItems = null,
    isShowingCaduque = false,
    ...rest
  } = props;

  const handleSelect = React.useCallback(
    (qualification: Profession, qualifications: Profession[]) => {
      _fn(onSelect, !_.isEmpty(qualifications) ? qualification : {});
    },
    [onSelect],
  );

  const filteredProfessions = professions.filter(
    (profession) => !profession.caduque,
  );

  return (
    <Liste title="" searchable onSearch={onSearch} loading={loading} {...rest}>
      <Liste.Content>
        <ProfessionListeTable
          items={isShowingCaduque ? professions : filteredProfessions}
          count={isShowingCaduque ? count : filteredProfessions.length}
          loading={loading}
          onLoad={onLoad}
          onSelect={handleSelect}
          perPage={perPage}
          onSort={onSort}
          onSave={onSave}
          selectedProfession={selectedProfession}
          resetSelectedItems={resetSelectedItems}
          isShowingCaduque={isShowingCaduque}
        />
      </Liste.Content>
    </Liste>
  );
};

export default ProfessionListe;
